import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { FormikProps } from 'formik';

import { AppDispatch } from 'app/store';
import usePortsRepository from 'hooks/usePortsRepository';

import Page from 'features/layout/components/Page';
import PageHeader from 'features/layout/components/PageHeader';

import {
  getCrew,
  getPortCallData,
  selectGeneralData,
} from '../../slices/portCallSlice';

import PortCallDataForm, {
  EtaAndEtdValues,
} from './components/PortCallDataForm';
import SkipAndNextButtons from './components/SkipAndNextButtons';

import './styles/port-call-data.scss';

const PortCallData = () => {
  const dispatch = useDispatch<AppDispatch>();
  const params = useParams();

  const generalPortcallData = useSelector(selectGeneralData);
  const { relations, unlocode } = generalPortcallData;
  const { port } = usePortsRepository({ ports: relations?.ports, unlocode });
  const portCallDataForm = useRef<FormikProps<EtaAndEtdValues>>(null);

  useEffect(() => {
    if (params?.uid !== undefined) {
      dispatch(getPortCallData(params.uid));
      dispatch(getCrew({ uid: params.uid, listType: 'arrival' }));
      dispatch(getCrew({ uid: params.uid, listType: 'departure' }));
    }
  }, [dispatch, params.uid]);

  return (
    <Page>
      <div className="port-call-data">
        <PageHeader
          title={'Port call data'}
          subtitle={`Provide the ETA and ETD for the Port of ${port && port.name}:`}
        />
        <PortCallDataForm formRef={portCallDataForm} />
      </div>
      <SkipAndNextButtons
        next={`/${params.uid}/vessel-data`}
        submitDisabled={false}
        onSubmitClick={async () => {
          portCallDataForm.current?.submitForm();
        }}
      />
    </Page>
  );
};

export default PortCallData;
